module.exports = __webpack_public_path__ + "static/006-d629c98e49ee4ca24baf696b274d852d.jpg";